import React from 'react';
import { Loader2 } from 'lucide-react';
import './Spinner.css';

interface SpinnerProps {
  size?: number;
  className?: string;
}

/** Loader2 de lucide girando. Un solo @keyframes para toda la app. */
export const Spinner: React.FC<SpinnerProps> = ({ size = 20, className = '' }) => (
  <Loader2 size={size} className={`al-spinner ${className}`} aria-hidden="true" />
);
